import React from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import ProtectedRoute from '@/components/layout/ProtectedRoute';
import { Toaster } from '@/components/ui/sonner';

import Login from '@/pages/Login';
import AuthCallback from '@/pages/AuthCallback';
import Dashboard from '@/pages/Dashboard';
import Tasks from '@/pages/Tasks';
import DailyReports from '@/pages/DailyReports';
import WeeklyDashboard from '@/pages/WeeklyDashboard';
import Expenses from '@/pages/Expenses';
import Exports from '@/pages/Exports';
import AdminUsers from '@/pages/AdminUsers';
import Profile from '@/pages/Profile';

const ROLES_EXPENSES = ['admin', 'accountant', 'ops_manager'];
const ROLES_EXPORTS = ['admin', 'ops_manager'];
const ROLES_ADMIN = ['admin'];

// Handles Google OAuth session_id in URL hash before routing normally.
function Router() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/tasks" element={<ProtectedRoute><Tasks /></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute><DailyReports /></ProtectedRoute>} />
      <Route path="/dashboard/weekly" element={<ProtectedRoute><WeeklyDashboard /></ProtectedRoute>} />
      <Route path="/expenses" element={<ProtectedRoute roles={ROLES_EXPENSES}><Expenses /></ProtectedRoute>} />
      <Route path="/exports" element={<ProtectedRoute roles={ROLES_EXPORTS}><Exports /></ProtectedRoute>} />
      <Route path="/admin/users" element={<ProtectedRoute roles={ROLES_ADMIN}><AdminUsers /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Router />
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
